<template>
  <Layout />
</template>

<script>
import Layout from '@pc/common/Layout'

export default {
  components: {
    Layout
  }
}
</script>
